import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../utils';
import './PackageNewCard.css'
import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import buffe from '../image/buffe.png'
import { IoLocationOutline } from "react-icons/io5";

import { BiDrink } from "react-icons/bi";

const url = `${API_BASE_URL}/master/assets/uploads/`
export default function PackageNewCard({ data, isBid, isFiltered }) {

    // console.log(data?.clubName, "data")


    const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }
    return (
        <>

            <div className='PackageNewCard'>
                <div className='PackageNewCard-image-section'>
                    {isBid ? (

                        <img
                            src={url + data?.clubLogo}
                            alt=""
                            onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
                            }}
                        />
                    ) : (
                        <img
                            src={url + data?.packageThumbnail || url + data?.clubLogo}
                            alt=""
                            onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
                            }}
                        />
                    )}

                </div>
                <div className='PackageNewCard-content-section'>
                    <div className='PackageNewCard-text-section'>
                        <h1>{data?.clubName}</h1>
                        <p> <div className='PackageNewCard-img-icon-section-icon'><img src={buffe} alt="" /> </div> {data?.title}</p>
                        {isBid ? (
                            <p><IoLocationOutline /> {data?.club_address?.length > 24 ? data?.club_address?.slice(0, 24) + "..." : data?.club_address}</p>
                        ) : (
                            <p><IoLocationOutline /> {data?.areaName || data?.area_name}{" "}{data?.cityName || data?.city_name}</p>
                        )}
                        <div className='PackageNewCard-text-section-food-time'>
                            <p> <IoRestaurant /> Food – 3h</p>
                            <p> <BiDrink /> Drinks – 1.5h</p>
                        </div>
                        {isBid ? (
                            <Link to={`/bid-detail/${data?.club_slug}/${format(data?.title)}/${data?.id}`}>
                                <div className='PackageNewCard-text-section-button'>
                                    <button>View Details</button>
                                </div>
                            </Link>
                        ) : (
                            <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName, data?.title)}>
                                <div className='PackageNewCard-text-section-button'>
                                    <button>View Details</button>
                                </div>
                            </Link>
                        )}
                    </div>
                    <div className='PackageNewCard-about-text-section'>
                        <div className='pnats-icon-wrapper'>

                            <div className='pnats-icon-wrapper-icon'>
                                <PiShareFatLight size={25} />
                            </div>
                            {isFiltered &&(
                                <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon2'>
                                <MdOutlineFilterAlt size={25} />
                                <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon3'>
                                    <MdOutlinePushPin size={10} />
                                </div>
                            </div>
                            )}
                        </div>
                        <h1>Features</h1>
                        <div>
                            <ul className='PackageNewCard-about-text-section-list'>
                                <li>Dance Floor</li>
                                <li>Led Screens</li>
                                <li>Lawn + Indoor Halls</li>
                                <li>Custom Decor</li>
                            </ul>
                        </div>
                        <p>8+ More</p>
                    </div>
                </div>

            </div>
        </>
    )
}
